import Vue from 'vue';
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import ossClient from './aliyun.oss.client';
import ElementUI from 'element-ui';
import store from '../vuex/store';
import utils from './util';
import wsMethod from './socketMethod'
var $base64 = require("js-base64").Base64;
var uploadConf = {
    accessKeyId: '',
    accessKeySecret: '',
    stsToken: '',
    bucket: 'aitestgo-bj-art',
    endpoint: 'oss-cn-beijing.aliyuncs.com',
    secure:true
}
var checkpoint_temp = null;
var uploadName = ''
var upload = ''
var ifcancel_i=false;
var ifcancel_a=false;
var ifcancel_v=false;
var ifcancel_d=false;
var ifcancel_t=false;
const parallel = 3;
const partSize = 1024 * 1024 *5;
var checkpoints = {};
var client = {};
var serial = '';
var upFiles = [];
var upFiles_name = [];
var errorNum = 0;//默认是aitestgo-bj 上传错误三次后更换为aitestgo-qd
//上传文件
export function uploadPic(file,callback){
    let that = this
    Vue.prototype.$axios.post('/oss/stsInfo/list',{
        uid:Number($base64.decode(window.localStorage.getItem('uid-web')))
    },res => {
        let v = res.data;
        if (v!=undefined&&v.code == 0) {
            let vlistVal = {}
            //2026-02-25 因国音需要驳回重传功能，重传时上次答题数据通过固定路径获取，所以鹏哥让指通过bj区上传，关闭切区功能
            // if(errorNum>=10){vlistVal = v.data[1]   
            // }else{vlistVal = v.data[0]}
            vlistVal = v.data[0]
            that.uploadConf.accessKeyId = vlistVal.accessKeyId
            that.uploadConf.accessKeySecret = vlistVal.accessKeySecret
            that.uploadConf.stsToken = vlistVal.securityToken//stsToken
            that.uploadConf.bucket = vlistVal.bucket
            that.uploadConf.endpoint = vlistVal.url.split(`${vlistVal.bucket}.`)[1]
            return callback(that.uploadConf)
        }
    });
}
export async function uploadHttp(file,callback,ossType='',serial='') {
    let that = this
    wsMethod.wsSend212()
    that.serial = serial
    that.judgeType(file)
    that.uploadPic(file,function (val) {
        // artPlatform/exam/online/试卷id/报名id_考生号.txt
        var fileName;
        if(ossType == 'ossType'){//上传答案json到oss和上传txt到oss
            fileName = file.name
        }else{
            var userSignId_ = utils.getUrlKey('userSignId')
            var bIdSign_ = `${utils.getUrlKey('bId')}${userSignId_? '/'+userSignId_:''}`
            fileName = `${process.env.ANSWER_OSS}/${bIdSign_}/${Date.parse(new Date())}${file.lastModified}${file.size}.`+file.name.split('.')[file.name.split('.').length-1];
        }
        upFiles_name.push({
            name:fileName,
            serial:serial,
        })
        upFiles.push(file)
        Nprogress.start()
        client = ossClient(val)
        ossClient(val).multipartUpload(fileName, file,{
            parallel:1,
            partSize: 1000 * 1024,
            timeout: 60000,
            progress:function(progress,checkpoint){
                checkpoint_temp = checkpoint
                if(checkpoint){//分片
                    upload = checkpoint.uploadId
                    uploadName = checkpoint.name
                }
                let tem = ossClient(val)
                that.pressJust(tem,file,progress,serial)
            }
        }).then(({res, url, name})=> {
            Nprogress.done()
            if (res && res.status == 200) {
                wsMethod.wsSend213()
                that.deleteUpfiles(name);
                let urls = String(res.requestUrls[0])
                // console.log(`阿里云OSS上传图片成功回调`, urls.split('?')[0]);
                return callback(decodeURIComponent(urls.split('?')[0],file))
            }
        }).catch(err=> {
            Nprogress.done()
            wsMethod.wsSend214()
            // console.log(`阿里云OSS上传图片失败回调`, err);
            // 捕获超时异常。
            if (ossClient(val) && ossClient(val).isCancel()) {
                console.log('stop-upload!');
            } else {
                Vue.prototype.resetSetItem(`doc_err_${serial}`, 'error');
                // ElementUI.Message({
                //     message: '上传失败',
                // })
                errorNum++; 
                return callback('')
            }
            // if (err.code === 'ConnectionTimeoutError'){}
        });
    })
}
// 恢复上传
export async function reUploadFile(serial='',callback) {
    let that = this
    let file,fileName;
    for (let i = 0; i < upFiles_name.length; i++) {
        if(upFiles_name[i].serial == serial){
            file = upFiles[i]
            fileName = upFiles_name[i].name
        }
    }
    wsMethod.wsSend212()
    that.judgeType(file)
    that.uploadPic(file,function (val) {
        // artPlatform/exam/online/试卷id/报名id_考生号.txt
        var fileName = fileName
        Nprogress.start()
        client = ossClient(val)
        ossClient(val).multipartUpload(fileName, file,{
            parallel:1,
            partSize: 1000 * 1024,
            timeout: 60000,
            progress:function(progress,checkpoint){
                checkpoint_temp = checkpoint
                if(checkpoint){//分片
                    upload = checkpoint.uploadId
                    uploadName = checkpoint.name
                }
                let tem = ossClient(val)
                that.pressJust(tem,file,progress,serial)
            },
            checkpoint: checkpoint_temp,
        }).then(({res, url, name})=> {
            Nprogress.done()
            if (res && res.status == 200) {
                wsMethod.wsSend213()
                that.deleteUpfiles(name);//删除缓存文件
                window.sessionStorage.removeItem(`doc_err_${serial}`)
                let urls = String(res.requestUrls[0])
                // console.log(`阿里云OSS上传图片成功回调`, urls.split('?')[0]);
                return callback(decodeURIComponent(urls.split('?')[0],file))
            }
        }).catch(err=> {
            Nprogress.done()
            wsMethod.wsSend214()
            // console.log(`阿里云OSS上传图片失败回调`, err);
            // 捕获超时异常。
            if (err.code === 'ConnectionTimeoutError') {}
            // ElementUI.Message({
            //     message: '上传失败',
            // })
            errorNum++;
            return callback('')
        });
    })
}
export function pressJust(ossClients,file,progress,serial) {
    if(file.type.indexOf("image") != -1){
        store.commit('get_imgRess',Number(utils.toPercent(progress)))
        this.cancego(ossClients,ifcancel_i,`image_${serial}`)
    }
    if(file.type.indexOf("audio") != -1){
        store.commit('get_audioRess',Number(utils.toPercent(progress)))
        this.cancego(ossClients,ifcancel_a,`audio_${serial}`)
    }
    if(file.type.indexOf("video") != -1){
        store.commit('get_videoRess',Number(utils.toPercent(progress)))
        this.cancego(ossClients,ifcancel_v,`video_${serial}`)
    }
    if(file.type.indexOf("doc") != -1||file.type.indexOf("zip") != -1){
        // store.commit('get_docRess',Number(utils.toPercent(progress)))
        Vue.prototype.resetSetItem(`doc_${serial}`, Number(utils.toPercent(progress)));
        this.cancego(ossClients,ifcancel_d,`doc_${serial}`)
    }
    if(file.type.indexOf("text") != -1){
        if(file.name.indexOf('本地加密文件')==-1)
        store.commit('get_textRess',Number(utils.toPercent(progress)))
        this.cancego(ossClients,ifcancel_t,`text_${serial}`)
    }
}
export function cancego(ossClients,ifcancel,name) {
    if(ifcancel){
        ifcancel = !ifcancel
        window.sessionStorage.removeItem(name)
        ossClients.cancel();
        ossClients.AbortMultipartUpload();
        return ''
    }
}
export function judgeType(file) {
    if(file.type.indexOf("image") != -1) ifcancel_i = false
    if(file.type.indexOf("audio") != -1) ifcancel_a = false
    if(file.type.indexOf("video") != -1) ifcancel_v = false
    if(file.type.indexOf("doc") != -1||file.type.indexOf("zip") != -1) ifcancel_d = false
    if(file.type.indexOf("text") != -1) ifcancel_t = false
}
export function cancelFun(val) {
    if(val == 'img') ifcancel_i = true
    if(val == 'audio') ifcancel_a = true
    if(val == 'video') ifcancel_v = true
    if(val == 'doc') ifcancel_d = true
    if(val == 'text') ifcancel_t = true
}
export function deleteUpfiles(name) {
    let that = this
    for (let i = 0; i < upFiles_name.length; i++) {
        if(upFiles_name[i].name == name){
            upFiles_name.splice(i,1);
            upFiles.splice(i,1);
        }
    }
}


export default {
    uploadConf,
    uploadPic,
    uploadHttp,
    cancelFun,
    pressJust,
    cancego,
    judgeType,
    deleteUpfiles,
    reUploadFile,
}


// WEBPACK FOOTER //
// ./src/lib/oss.js